import React, { ComponentProps, CSSProperties, ReactElement } from 'react';

import { CSSObject } from 'styled-components';

import LoadMoreData from '@adsk/alloy-react-load-more-data';
import { useTheme } from '@adsk/alloy-react-styles';

import useTableSize from '../hooks/useTableSize';
import { Themeable } from '../types';

type LoadMoreDataProps = ComponentProps<typeof LoadMoreData> & Themeable;

const LoadMoreDataFooter = ({
  style = {},
  tableSize,
  ...props
}: LoadMoreDataProps): ReactElement => {
  const tableSizeTheme = useTableSize(tableSize);
  const theme = useTheme();
  const loadMore = theme.tokens?.component?.table?.loadMore;

  return (
    <LoadMoreData
      style={{
        height: tableSizeTheme.rowHeight,
        position: 'sticky',
        margin: 0,
        bottom: 0,
        left: 0,
        zIndex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        minHeight: tableSizeTheme.rowHeight,
        padding: `0 ${tableSizeTheme.cellPadding}px`,
        background: loadMore?._?.background,
        borderTopWidth: loadMore?._?.['border-top-width'],
        borderTopStyle: loadMore?._?.[
          'border-top-style'
        ] as CSSProperties['borderTopStyle'],
        borderTopColor: loadMore?._?.['border-top-color'],
        ...(style as CSSObject),
      }}
      {...props}
    />
  );
};

LoadMoreDataFooter.propTypes = LoadMoreData.propTypes;

export default LoadMoreDataFooter;
